import React from "react"
import { Text } from "dash-styled"
import { fromNow } from "../../../../../../Helpers/Functions/dateFormat"
import { APIJobFeedbackMessageModel } from "../../../../../../Models/API/JobModel"
import { TableColumn } from "resha"
import { JobStatusPill } from "../Common/JobStatusPill"
import { ColumnsProps } from "./JobsListTable/JobsListTable"
import { FeedbackTagsHeader } from "./FeedbackTagsHeader"
import { FeedbackMessageViewState } from "../../../../../../Models/API/JobFeedbackModel"

export const messageColumns: (
    vals: ColumnsProps<APIJobFeedbackMessageModel>
) => TableColumn<APIJobFeedbackMessageModel>[] = ({
    orgUsername,
    appID,
    sort
}) => [
    {
        renderHeader: () => "Data point",
        render: ({ id, feedbackMessage }) => (
            <Text
                className={`m-0 whitespace-no-wrap truncate ${
                    feedbackMessage?.viewState ===
                    FeedbackMessageViewState.UNREAD
                        ? "text-grape-800"
                        : "text-smoke-610"
                }`}
                weight="semibold"
                size="sm"
            >
                {id}
            </Text>
        ),
        className: "w-2/12"
    },
    {
        renderHeader: () => "Message",
        render: ({ feedbackMessage, feedbackTags }) => {
            return (
                <div className="flex items-center truncate">
                    {feedbackTags && (
                        <FeedbackTagsHeader
                            orgUsername={orgUsername}
                            feedbackTags={feedbackTags}
                            sort={sort}
                            appID={appID}
                            showOnlyChildTags={true}
                        />
                    )}
                    <Text
                        className={`m-0 whitespace-no-wrap truncate ${
                            feedbackMessage?.viewState ===
                            FeedbackMessageViewState.UNREAD
                                ? "text-grape-800"
                                : "text-smoke-610"
                        }`}
                        size="sm"
                        weight={
                            feedbackMessage?.viewState ===
                            FeedbackMessageViewState.UNREAD
                                ? "semibold"
                                : "regular"
                        }
                    >
                        {feedbackMessage?.message}
                    </Text>
                </div>
            )
        },
        className: "text-smoke-610",
        headerClassName: "w-1/2"
    },
    {
        renderHeader: () => "Last message",
        render: ({ created, feedbackMessage }) => (
            <Text
                className={`m-0 whitespace-no-wrap truncate ${
                    feedbackMessage?.viewState ===
                    FeedbackMessageViewState.UNREAD
                        ? "text-grape-800"
                        : "text-smoke-610"
                }`}
                size="sm"
            >
                {fromNow(
                    feedbackMessage && feedbackMessage.created
                        ? feedbackMessage.created
                        : created
                )}
            </Text>
        ),
        className: "w-2/12 text-smoke-610"
    },
    {
        renderHeader: () => "Status",
        render: (job, isChecked) => {
            return <JobStatusPill job={job} />
        },
        className: "w-2/12 overflow-auto"
    }
]
